'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _awaitAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var _require = require('streaming-iterables'),
    map = _require.map;

var errcode = require('err-code');
/**
 * BlockService is a hybrid block datastore. It stores data in a local
 * datastore and may retrieve data from a remote Exchange.
 * It uses an internal `datastore.Datastore` instance to store values.
 */


var BlockService = /*#__PURE__*/function () {
  /**
   * Create a new BlockService
   *
   * @param {IPFSRepo} ipfsRepo
   */
  function BlockService(ipfsRepo) {
    _classCallCheck(this, BlockService);

    this._repo = ipfsRepo;
    this._bitswap = null;
  }
  /**
   * Add a bitswap instance that communicates with the
   * network to retreive blocks that are not in the local store.
   *
   * If the node is online all requests for blocks first
   * check locally and afterwards ask the network for the blocks.
   *
   * @param {Bitswap} bitswap
   * @returns {void}
   */


  _createClass(BlockService, [{
    key: "setExchange",
    value: function setExchange(bitswap) {
      this._bitswap = bitswap;
    }
    /**
     * Go offline, i.e. drop the reference to bitswap.
     *
     * @returns {void}
     */

  }, {
    key: "unsetExchange",
    value: function unsetExchange() {
      this._bitswap = null;
    }
    /**
     * Is the blockservice online, i.e. is bitswap present.
     *
     * @returns {bool}
     */

  }, {
    key: "hasExchange",
    value: function hasExchange() {
      return this._bitswap != null;
    }
    /**
     * Put a block to the underlying datastore.
     *
     * @param {Block} block
     * @param {Object} [options] -  Options is an object with the following properties
     * @param {AbortSignal} [options.signal] - A signal that can be used to abort any long-lived operations that are started as a result of this operation
     * @returns {Promise}
     */

  }, {
    key: "put",
    value: function put(block, options) {
      if (this.hasExchange()) {
        return this._bitswap.put(block, options);
      } else {
        return this._repo.blocks.put(block, options);
      }
    }
    /**
     * Put a multiple blocks to the underlying datastore.
     *
     * @param {AsyncIterator<Block>} blocks
     * @param {Object} [options] -  Options is an object with the following properties
     * @param {AbortSignal} [options.signal] - A signal that can be used to abort any long-lived operations that are started as a result of this operation
     * @returns {Promise}
     */

  }, {
    key: "putMany",
    value: function putMany(blocks, options) {
      if (this.hasExchange()) {
        return this._bitswap.putMany(blocks, options);
      } else {
        return this._repo.blocks.putMany(blocks, options);
      }
    }
    /**
     * Get a block by cid.
     *
     * @param {CID} cid
     * @param {Object} [options] -  Options is an object with the following properties
     * @param {AbortSignal} [options.signal] - A signal that can be used to abort any long-lived operations that are started as a result of this operation
     * @returns {Promise<Block>}
     */

  }, {
    key: "get",
    value: function get(cid, options) {
      if (this.hasExchange()) {
        return this._bitswap.get(cid, options);
      } else {
        return this._repo.blocks.get(cid, options);
      }
    }
    /**
     * Get multiple blocks back from an array of cids.
     *
     * @param {AsyncIterator<CID>} cids
     * @param {Object} [options] -  Options is an object with the following properties
     * @param {AbortSignal} [options.signal] - A signal that can be used to abort any long-lived operations that are started as a result of this operation
     * @returns {AsyncIterator<Block>}
     */

  }, {
    key: "getMany",
    value: function getMany(cids, options) {
      var _this = this;

      if (!Array.isArray(cids)) {
        throw new Error('first arg must be an array of cids');
      }

      if (this.hasExchange()) {
        return this._bitswap.getMany(cids, options);
      } else {
        var getRepoBlocks = map(function (cid) {
          return _this._repo.blocks.get(cid, options);
        });
        return getRepoBlocks(cids);
      }
    }
    /**
     * Delete a block from the blockstore.
     *
     * @param {CID} cid
     * @param {Object} [options] -  Options is an object with the following properties
     * @param {AbortSignal} [options.signal] - A signal that can be used to abort any long-lived operations that are started as a result of this operation
     * @returns {Promise}
     */

  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cid, options) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._repo.blocks.has(cid);

              case 2:
                if (_context.sent) {
                  _context.next = 4;
                  break;
                }

                throw errcode(new Error('blockstore: block not found'), 'ERR_BLOCK_NOT_FOUND');

              case 4:
                return _context.abrupt("return", this._repo.blocks.delete(cid, options));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _delete(_x, _x2) {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
    /**
     * Delete multiple blocks from the blockstore.
     *
     * @param {AsyncIterator<CID>} cids
     * @param {Object} [options] -  Options is an object with the following properties
     * @param {AbortSignal} [options.signal] - A signal that can be used to abort any long-lived operations that are started as a result of this operation
     * @returns {Promise}
     */

  }, {
    key: "deleteMany",
    value: function deleteMany(cids, options) {
      var repo = this._repo;
      return this._repo.blocks.deleteMany(_wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, cid;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _context2.prev = 2;
                _iterator = _asyncIterator(cids);

              case 4:
                _context2.next = 6;
                return _awaitAsyncGenerator(_iterator.next());

              case 6:
                _step = _context2.sent;
                _iteratorNormalCompletion = _step.done;
                _context2.next = 10;
                return _awaitAsyncGenerator(_step.value);

              case 10:
                _value = _context2.sent;

                if (_iteratorNormalCompletion) {
                  _context2.next = 22;
                  break;
                }

                cid = _value;
                _context2.next = 15;
                return _awaitAsyncGenerator(repo.blocks.has(cid));

              case 15:
                if (_context2.sent) {
                  _context2.next = 17;
                  break;
                }

                throw errcode(new Error('blockstore: block not found'), 'ERR_BLOCK_NOT_FOUND');

              case 17:
                _context2.next = 19;
                return cid;

              case 19:
                _iteratorNormalCompletion = true;
                _context2.next = 4;
                break;

              case 22:
                _context2.next = 28;
                break;

              case 24:
                _context2.prev = 24;
                _context2.t0 = _context2["catch"](2);
                _didIteratorError = true;
                _iteratorError = _context2.t0;

              case 28:
                _context2.prev = 28;
                _context2.prev = 29;

                if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                  _context2.next = 33;
                  break;
                }

                _context2.next = 33;
                return _awaitAsyncGenerator(_iterator.return());

              case 33:
                _context2.prev = 33;

                if (!_didIteratorError) {
                  _context2.next = 36;
                  break;
                }

                throw _iteratorError;

              case 36:
                return _context2.finish(33);

              case 37:
                return _context2.finish(28);

              case 38:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 24, 28, 38], [29,, 33, 37]]);
      }))(), options);
    }
  }]);

  return BlockService;
}();

module.exports = BlockService;